import { useLoadingStore } from '../../store/loadingStore';
import { useGlobalErrStore } from '../../store/errorStore';
import { convertStringToErrorCode } from '../../api/errorCode';


export const useApiWrapperWithReturn = () => {
  const { addLoading, popLoading } = useLoadingStore();
  const { setManagedErr, clearErr } = useGlobalErrStore();

    // ---------------------------
  // 공용: 에러 파싱 + 스토어 세팅
  // ---------------------------
  const handleManagedError = (err: unknown, fallbackCode: string = 'AWS') => {
    const rawErrorMessage = err instanceof Error ? err.message : 'An unexpected error occurred';

    let errorCode = fallbackCode;

    // "CODE::message" 형식이면 CODE만 뽑고,
    // 아니면 메시지 전체를 code 후보로 사용 (기존 로직 호환)
    if (rawErrorMessage.includes('::')) {
      [errorCode] = rawErrorMessage.split('::').map((s) => s.trim());
    } else {
      errorCode = rawErrorMessage.trim() || fallbackCode;
    }

    setManagedErr({
      errCode: convertStringToErrorCode(errorCode),
    });
  };


  // ---------------------------
  // 공용: loading + error wrapper
  // ---------------------------
  const apiWrapperWithReturn = async <T,>(
    action: () => Promise<T>,
    fallbackCode: string = 'AWS'
  ): Promise<T | null> => {
    addLoading();
    clearErr();

    try {
      return await action();
    } catch (err) {
      handleManagedError(err, fallbackCode);
      return null;
    } finally {
      popLoading();
    }
  };

  return {apiWrapperWithReturn};
};